import TR from 'utils/TR';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import T from 'utils/T';
import ex from 'utils/ex';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import * as Luxon from 'luxon';
import React from 'react';
import GuideButton from '../Report/GuideButton';

export default function DrGuideBox(props) {
  const {
    data,
    ...rest
  } = props || {};


  // 데이터가 변할때마다 다시 계산
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const today = React.useMemo(() => Luxon.DateTime.now().toFormat('yyyyMMddHHmmss'), [data]);

  const {
    dr_guide_active_content,
    dr_guide_active_record_time = today,
    dr_guide_meal_content,
    dr_guide_meal_record_time = today,
    dr_guide_insulin_content,
    dr_guide_insulin_record_time = today,
  } = data || {};

  return (
    <div {...ex('DrGuideBoxes', props)}>
      <Segment {...ex('DrGuideBox', { direction: DIRECTION_VERTICAL })} full>
        <div>
          <div {...ex(['GuideTag', 'diet'])}>
            {T('Dr.Guide 식사')}
          </div>
          <div {...ex('GuideDate')}>
            {T('{0} 발행', Luxon.DateTime.fromFormat(dr_guide_meal_record_time, 'yyyyMMddHHmmss').toFormat('yy.MM.dd'))}
          </div>
        </div>
        <div {...ex('GuideContents')}>
          {dr_guide_meal_content}
        </div>
        {/* <GuideButton {...rest} {...{ type: 'diet' }} /> */}
      </Segment>

      <Segment {...ex('DrGuideBox', { direction: DIRECTION_VERTICAL })} full>
        <div>
          <div {...ex(['GuideTag', 'exercise'])}>
            {T('Dr.Guide 활동')}
          </div>
          <div {...ex('GuideDate')}>
            {T('{0} 발행', Luxon.DateTime.fromFormat(dr_guide_active_record_time, 'yyyyMMddHHmmss').toFormat('yy.MM.dd'))}
          </div>
        </div>
        <div {...ex('GuideContents')}>
          {dr_guide_active_content}
        </div>
        {/* <GuideButton {...rest} {...{ type: 'exercise' }} /> */}
      </Segment>

      <Segment {...ex('DrGuideBox', { direction: DIRECTION_VERTICAL })} full>
        <div>
          <div {...ex(['GuideTag', 'insulin'])}>
            {T('Dr.Guide 인슐린')}
          </div>
          <div {...ex('GuideDate')}>
            {T('{0} 발행', Luxon.DateTime.fromFormat(dr_guide_insulin_record_time, 'yyyyMMddHHmmss').toFormat('yy.MM.dd'))}
          </div>
        </div>
        <div {...ex('GuideContents')}>
          {dr_guide_insulin_content}
        </div>
        {/* <GuideButton {...rest} {...{ type: 'insulin' }} /> */}
      </Segment>
    </div >
  );
}
